import Slider from "./components/Slider";
import "./components/datepicker.js";
import { DeparturePicker } from "./components/departure-picker.js";
import inputPopover from "./components/input-popover.js";
import { FormGuide, FormGuideDefaults } from "./components/form-guide";
import { InputGuests } from "./components/input-guests";
import functions from "./functions";
import { Select2 } from "./components/select2";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';
import lozad from 'lozad';


$(function ()
{

	$('[name="offerType"]').on('change', e =>
	{
		const $target = $(e.currentTarget);
		let offerType = $target.val();

		const $tabs = $('#searchHomeTab');
		let $tab = $tabs.find('[id="' + offerType + '"]');
		$tab.tab('show');
	});

	$('.btn-level').on('click', e =>
	{
		e.preventDefault();
		e.stopPropagation();
		const $target = $(e.currentTarget);
		$target.toggleClass('show', !$target.hasClass('show'));

		const $sibling = $target.siblings('.dropdown-submenu');
		$sibling.toggleClass('show', !$sibling.hasClass('show'));
	})

	$('a[href="' + window.location.href + '"]:not(.navbar-brand)').addClass('active-link');
	$('a[href="' + window.location.pathname + '"]:not(.navbar-brand)').addClass('active-link');


	$(".select2").each((i, elem) =>
	{
		elem._select2 = new Select2(elem);
	});

	$('.form-guide').each((i, elem) =>
	{
		elem._formGuide = new FormGuide(elem);
	});

	$('.datepicker.departure-picker [data-input]').each((i, elem) =>
	{
		elem._departurePicker = new DeparturePicker(elem);
	});

	$('.input-guests').each((i, elem) =>
	{
		elem._inputGuests = new InputGuests(elem);
	});

	inputPopover.apply();

	$('.search-form label').on('click', e =>
	{
		const $target = $(e.currentTarget);
		const $elem = $target.find('.select2-search__field');
		$elem[0] && $elem.focus();
	});

	$(document).on('click', '[data-scroll-to]', e =>
	{
		e.preventDefault();
		const $this = $(e.target);
		console.log($this);
		let scrollTo = $this.attr('data-scroll-to').split(',');
		functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
	});

	$('#collapseItinerary').on('show.bs.collapse', e =>
	{
		$('.show-itinerary').addClass('d-none');
	});
	$('#collapseItinerary').on('hide.bs.collapse', e =>
	{
		$('.show-itinerary').removeClass('d-none');
	});

	$('#collapseMeetPoints').on('show.bs.collapse', e =>
	{
		$('.show-points').addClass('d-none');
	});
	$('#collapseMeetPoints').on('hide.bs.collapse', e =>
	{
		$('.show-points').removeClass('d-none');
	});

	if ($('#hero-slider')[0])
	{
		const length = $('#hero-slider').children('.keen-slider__slide').length;
		new Slider($('#hero-slider'), {
			rubberband: false,
			loop: length > 1 ? true : false,
			arrows: length > 1 ? true : false,
			pager: length > 1 ? true : false,
			autoplay: 6000,
			slides: {
				perView: 1,
				spacing: 0,
			},
			defaultAnimation: {
				duration: 1200,
			},
		});
	}

	let objectsSlider = [];

	if ($('[id^=objects-slider]')[0])
	{
		$('[id^=objects-slider]').each((i, elem) =>
		{
			objectsSlider[i] = new Slider('#' + $(elem).attr('id'), {
				rubberband: false,
				loop: false,
				arrows: true,
				pager: true,
				slides: {
					perView: 1,
					spacing: 32,
				},
				breakpoints: {
					'(max-width: 1390px)': {
						slides: {
							perView: 1,
						},
					},
					'(max-width: 768px)': {
						slides: {
							perView: 1.1,
							spacing: 0
						},
					},
				}
			});
		});
	}

	let contentSlider = [];

	if ($('[id^=content-slider]')[0])
	{
		$('[id^=content-slider]').each((i, elem) =>
		{
			contentSlider[i] = new Slider('#' + $(elem).attr('id'), {
				rubberband: false,
				loop: false,
				arrows: true,
				pager: true,
				slides: {
					perView: 2,
					spacing: 32,
				},
				defaultAnimation: {
					duration: 1200,
				},
				breakpoints: {
					'(max-width: 1390px)': {
						slides: {
							perView: 1.5,
							spacing: 24,
						},
					},
					'(max-width: 768px)': {
						slides: {
							perView: 1.1,
							spacing: 12
						},
					},
				}
			});
		});
	}

	if (functions.getCookie('cookie_usage') !== 'accepted')
	{
		$("#cookie-bar").removeClass('d-none');
	}

	$('#cookie-bar-accept').on('click', function (e)
	{
		functions.setCookie('cookie_usage', 'accepted');
		$("#cookie-bar").addClass('d-none');
	});

	functions.favoritesLabel();

	const $wpGallerys = $('.wp-block-gallery:not(.collage-gallery)');
	$wpGallerys.each((index, wpGallery) =>
	{
		let $wpGallery = $(wpGallery);
		const $wpGalleryLinks = $wpGallery.find('.wp-block-image');
		const wpGalleryArray = $wpGalleryLinks.map((i, elem) =>
		{
			const $elem = $(elem);
			const $img = $elem.find('img');
			let imgs = $img.attr('src').split(', ');
			// let imgs = $img.attr('srcset').split(', ');
			let sizes = $.map(imgs, img =>
			{
				let size = img.match(/(\d+)w$/);
				return size ? +size[1] : 9999;
			});
			let minSize = sizes.indexOf(Math.min.apply(Math, sizes));
			minSize = minSize > -1 ? minSize : 0;

			let img = imgs[minSize].replace(/ \d+w$/, '');
			return {
				src: $img.attr('src'),
				thumb: img
			};
		});

		$wpGallery.on('click', '.wp-block-image', e =>
		{
			e.preventDefault();
			let index = $wpGalleryLinks.index(e.currentTarget);

			if ($(e).hasClass('lg-on'))
			{
				$(e).data('lightGallery').index = index;
				$(e).data('lightGallery').build(index);
			} else
			{
				$(e).lightGallery({
					dynamic: true,
					thumbnail: true,
					toogleThumb: false,
					thumbWidth: 130,
					thumbMargin: 10,
					download: false,
					autoplay: false,
					preload: 2,
					index: index,
					dynamicEl: wpGalleryArray
				}).addClass('lg-on');
			}
		});

		$wpGallery.each((i, elem) =>
		{
			const $links = $(elem).find('.wp-block-image');
			let eq = $links.length >= 3 ? 2 : $links.length - 1;
			$links.eq(eq).append(
				`<div class="see-all-images position-absolute bottom-0 end-0 px-3 py-4 d-lg-block d-none">
            <div class="w-auto btn btn-primary text-dark rounded fw-bold" data-gallery-id="gallery-section" data-index="0">
                Galerija (${wpGalleryArray.length})
            </div>
        </div>`
			);
			$links.eq(0).append(
				`<div class="see-all-images position-absolute bottom-0 end-0 px-3 py-3 d-lg-none d-block">
            <div class="w-auto btn btn-primary text-dark rounded fw-bold" data-gallery-id="gallery-section" data-index="0">
                Galerija (${wpGalleryArray.length})
            </div>
        </div>`
			);
		});
	})

	$('.card-mosaic').on('click', e => e.preventDefault());

	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl)
	{
		return new bootstrap.Tooltip(tooltipTriggerEl);
	});

	$('.summary-large-show').on('click', e =>
	{
		const $target = $(e.currentTarget);
		const $summary = $('.summary-large');
		const isShowen = $summary.hasClass('show');

		$summary.toggleClass('show', !isShowen);
		$target.text(isShowen ? $target.attr('data-show') : $target.attr('data-hide'));
	});

	window.showmoreobserver = lozad('.show-more', {
		rootMargin: '200px 200px',
		loaded: elem =>
		{
			$(elem).triggerHandler('lozadLoaded');
			let $showMore = $(elem);

			let height = $showMore.attr('data-height');

			if ($showMore.find('.show-more-content').outerHeight() < height)
			{
				$showMore.addClass('removeBefore');
				$showMore.next('.show-more-expand').remove();
				return;
			}

			//let $breakpoint = $showMore.find('.show-more-breakpoint');
			if (height)
			{
				$showMore.css('max-height', + height);
			}
			// else if ($breakpoint.length)
			// {
			//     $showMore.css('max-height', $breakpoint.offset().top - $showMore.offset().top - 25);
			// }
			else
			{
				let $maxHeight = functions.isMobile() ?
					($showMore.outerHeight() * 0.15) :
					($showMore.outerHeight() * 0.3);

				$showMore.css('max-height', $maxHeight);
			}

			$showMore.next('.show-more-expand').on('click', e =>
			{
				let $prevSibling = $(e.currentTarget).prev();
				let $maxHeight
				if ($prevSibling.hasClass('removeBefore'))
				{
					let height = $prevSibling.attr('data-height');
					let $breakpoint = $prevSibling.find('.show-more-breakpoint');
					if (height)
					{
						$maxHeight = +height;
					}
					else if ($breakpoint.length)
					{
						$maxHeight = $breakpoint.offset().top - $showMore.offset().top - 25;
					}
					else
					{
						$maxHeight = functions.isMobile() ?
							($prevSibling.outerHeight() * 0.15) :
							($prevSibling.outerHeight() * 0.3);
					}
					$prevSibling.css('max-height', $maxHeight);
					$prevSibling.removeClass('removeBefore');

				}
				else
				{
					let $content = $prevSibling.find('.show-more-content');
					$prevSibling.css('max-height', $content.outerHeight());
					$prevSibling.addClass('removeBefore');
				}
			})
		}
	});
	window.showmoreobserver.observe();


	$('.form-field').on('click', e =>
	{
		// e.stopPropagation();
		let $elem = $(e.currentTarget);
		setTimeout(() =>
		{
			if ($(e.target).hasClass('simple-guests-apply')) return;
			if ($(e.target).hasClass('btn-month')) return;
			if ($(e.target).hasClass('month')) return;
			if ($(e.target).hasClass('year')) return;
			if ($(e.target).hasClass('dropdown-menu')) return;
			if ($elem.find('.form-control.input-popover').length) bootstrap.Dropdown.getOrCreateInstance($elem.find('.form-control.input-popover')[0]).show();
			if ($elem.find('.datepicker-range').length) $elem.find('.datepicker-range')[0]._flatpickr.open();
			if ($elem.find('.input-guests').length) $elem.find('.input-guests').dropdown('show');
			if ($elem.find('.form-guide').length) $elem.find('.form-guide')[0]._formGuide.show();
			if ($elem.find('.select2.form-control').length) $elem.find('.select2.form-control').select2('open');
		});
	});


});

